import ImageGalleryJs from '../../component/ImageGalleryhai';
import Project from '../../component/Project';
import worldTradeCentreData from '../../data/MallofMuscat.json';

const MallofMuscat = () => {
  const { pageData, containerData, content, images, styles } = worldTradeCentreData;
  return (<>
      <Project pageData={pageData} containerData={containerData} content={content} images={images} styles={styles} />
      <ImageGalleryJs/>
 </>)
}

export default MallofMuscat
